import React from 'react';

/**
 * Inject props into one or many JSX.Element's
 * @param element The element or elements to inject props
 * @param props The props to inject
 * @param key The key prop to be applied to the element
 * @returns {element} with injected {props}
 */
export const cloneElementWithProps = <ComponentPropType>(
  element: JSX.Element | JSX.Element[],
  props:
    | Partial<ComponentPropType>
    | ((props: ComponentPropType) => Partial<ComponentPropType>),
  key: string = 'component'
) => {
  return React.Children.map(element, (child: JSX.Element, index: number) => {
    if (React.isValidElement<ComponentPropType>(child)) {
      return React.cloneElement<ComponentPropType>(child, {
        key: `${key}-${index}`,
        ...child.props,
        ...(typeof props === 'function' ? props(child.props) : props),
      });
    }
    return child;
  });
};
